import React, { useContext } from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { DesignContext } from 'contexts/DesignContext'
import { Card } from 'react-bootstrap'
import objectPath from 'object-path'
import ModalComponent from 'designer/component/component/Modal'
import { createDesignerData } from 'designer/component/action/Design'
import Icon from 'designer/component/element/Icon'
import _ from 'lodash'
import {
  isExternalApiUrl,
  ROUTE_API,
  ROUTE_HIS,
} from 'designer/component/action/Config'
import Title from '../title/Title'
import { getPath } from 'designer/component/action/Action'

const CustomCard = (props) => {
  let { uischema, children } = props
  let uiKey = uischema.key
  const style = {
    header: {
      background: uischema.cardColor,
    },
    border: {
      border: '1px solid ' + uischema.cardColor,
      margin: uischema.layoutMargin,
    },
    title: {
      color: uischema.textColor,
    },
  }

  const designContext = useContext(DesignContext)
  const {
    setUischema,
    jsonForm,
    findUischemaIndex,
    setOpenModal,
    setFormData,
    perspectiveRoute,
    setDesignerPropsData,
    searchData,
  } = designContext
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  const isOpenModal = designContext.openModal

  let history = useHistory()
  const match = useRouteMatch()
  const location = useLocation()
  let action = objectPath.get(uischema, 'action') || {}
  let formData = objectPath.get(jsonForm, 'formData') || {}
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  const search = location.search || []
  const receivePathParams = match.params
  const urlSearchParams = new URLSearchParams(search)
  const receiveQueryParams = Object.fromEntries([...urlSearchParams])
  const allParams = { ...receivePathParams, ...receiveQueryParams }

  const goToForm = (action) => {
    if (!action.formCode) return
    let path = `/display/form/${action.formCode}`
    path = getPath(path, action, allParams)
    let queryString = []
    if (action.routerParams) {
      let routerParams = action.routerParams
      routerParams.forEach(({ param, paramType, key, value }) => {
        let paramValue
        if (paramType === 'input') {
          paramValue = formData[key]
        } else if (paramType === 'condition') {
          paramValue = value
        } else if (paramType === 'datasource') {
          paramValue = objectPath.get(datasourceValue, value)
        } else if (paramType === 'urlParam') {
          paramValue = objectPath.get(allParams, value)
        }
        if (paramValue !== null && paramValue !== undefined) {
          queryString.push(`${param}=${paramValue}`)
        }
      })
    }

    let historyData = {
      pathname: path,
      search: '?' + queryString.join('&'),
    }

    if (action.props) {
      let propList = action.props
      propList.map((prop) => {
        if (prop.propType === 'input' && prop.key) {
          let value = formData[prop.key]
          prop.value = value
        }
        if (prop.propType === 'formData' && formData.props) {
          let value = formData.props[prop.prop]
          prop.value = value
        }

        return prop
      })

      let pageCode = objectPath.set(
        jsonForm,
        'props.system.props.pageCode.value',
      )

      if (pageCode) {
        propList.push({
          prop: 'pageCode',
          propType: 'system',
          value: pageCode,
        })
      }

      historyData.state = propList
    } else {
      historyData.state = null
      setFormData({})
    }
    if (action?.openNewTab) {
      let path = historyData.pathname + historyData.search
      window.open(ROUTE_HIS + path, '_blank')
    } else {
      history.push(historyData)
    }

    return { status: 200 }
  }

  const goToPage = (action) => {
    let state = location.state || []
    let formCode = action.formCode
    let pageProp = state.find(
      (item) => item.prop === 'pageCode' && item.propType === 'system',
    )
    if (action.sourceType === 'pageCode') {
      formCode = pageProp?.value || ''
    }
    if (!formCode) return
    let path = `/display/page/${formCode}`
    path = getPath(path, action, allParams)
    let queryString = []
    if (action.routerParams) {
      let routerParams = action.routerParams
      routerParams.forEach(({ param, paramType, key, value }) => {
        let paramValue
        if (paramType === 'input') {
          paramValue = formData[key]
        } else if (paramType === 'condition') {
          paramValue = value
        } else if (paramType === 'datasource') {
          paramValue = objectPath.get(datasourceValue, value)
        } else if (paramType === 'urlParam') {
          paramValue = objectPath.get(allParams, value)
        }
        if (paramValue !== null && paramValue !== undefined) {
          queryString.push(`${param}=${paramValue}`)
        }
      })
    }

    let historyData = {
      pathname: path,
      search: '?' + queryString.join('&'),
    }

    if (action.props) {
      let propList = action.props
      propList.map((prop) => {
        if (prop.propType === 'input' && prop.key) {
          let value = formData[prop.key]
          prop.value = value
        }
        if (prop.propType === 'formData' && formData.props) {
          let value = formData.props[prop.prop]
          prop.value = value
        }
        return prop
      })
      historyData.state = propList
    } else {
      historyData.state = null
      setFormData({})
    }
    if (action?.openNewTab) {
      let path = historyData.pathname + historyData.search
      window.open(`${ROUTE_HIS}/${path}`, '_blank')
    } else {
      history.push(historyData)
    }

    return { status: 200 }
  }

  const goToUrl = ({
    url = '',
    linkType = '',
    pagePath = '',
    pathParams = [],
    queryParams = [],
    openNewTab = false,
    apiType = '',
    service = '',
    endpoint = '',
    api = '',
  }) => {
    if (linkType === 'internal') {
      url = pagePath
    } else if (linkType === 'api') {
      url = apiType === 'internal' ? service + endpoint : api
    }
    if (pathParams) {
      pathParams.forEach(({ param, propType, key, value, sourceKey }) => {
        let paramValue
        if (propType === 'datasource') {
          paramValue = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
        } else if (propType === 'urlParam') {
          paramValue = objectPath.get(allParams, key)
        } else if (propType === 'input') {
          paramValue = objectPath.get(formData, key)
        } else {
          paramValue = value
        }
        url = url.replace(`:${param}`, paramValue)
      })
    }
    if (queryParams) {
      let queryString = []
      queryParams.forEach(({ param, propType, key, value, sourceKey }) => {
        let paramValue
        if (propType === 'datasource') {
          paramValue = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
        } else if (propType === 'urlParam') {
          paramValue = objectPath.get(allParams, key)
        } else if (propType === 'input') {
          paramValue = objectPath.get(formData, key)
        } else {
          paramValue = value
        }
        if (paramValue !== null && paramValue !== undefined) {
          queryString.push(`${param}=${paramValue}`)
        }
      })
      if (queryString.length > 0) {
        let connect = url.indexOf('?') > -1 ? '&' : '?'
        url = url ? url + connect + queryString.join('&') : url
      }
    }
    let target = openNewTab ? '_blank' : '_self'
    if (linkType === 'api') {
      if (url.startsWith('/')) {
        window.open(ROUTE_API + url, target)
      } else {
        window.open(`${ROUTE_API}/` + url, target)
      }
    } else if (isExternalApiUrl(linkType, url)) {
      window.open(url, target)
    } else if (url.startsWith('http')) {
      window.open(url, target)
    } else if (url.startsWith('/')) {
      window.open(ROUTE_HIS + url, target)
    } else {
      window.open(`${ROUTE_HIS}/` + url, target)
    }
    return { status: 200 }
  }

  const clearCondition = (action) => {
    let { formId } = action
    if (formId) {
      objectPath.set(formData, `@condition.${formId}`, {})
    }
    setFormData(formData)
    return formData
  }

  const getModal = (form, modalKey) => {
    let elements = form.uischema.elements
    let mapKey = form.schema.mapKey[modalKey]
    let indices = findUischemaIndex(modalKey, mapKey, elements)
    let modalElement = indices.reduce((o, i) => o.elements[i], { elements })
    return modalElement
  }

  const openModal = async (action) => {
    formData = clearCondition(action)
    let modalKey = objectPath.get(action, 'modal.key')
    if (action.modalType === 'internal') {
      let elements = jsonForm.uischema.elements
      let modalElement = getModal(jsonForm, modalKey)
      modalElement.isOpen = true
      let newUiSchema = jsonForm.uischema
      newUiSchema.elements = elements
      setUischema(newUiSchema)
      setOpenModal(uischema.modal)
    } else if (action.modalType === 'external') {
      objectPath.set(designerPropsData, 'modal', action.formCode)
      designerPropsData = createDesignerData(
        designerPropsData,
        searchData,
        formData,
      )
      setDesignerPropsData(designerPropsData)
      setOpenModal(uiKey)
    } else if (action.modalType === 'component') {
      objectPath.set(designerPropsData, 'modal', action.component)
      designerPropsData = createDesignerData(
        designerPropsData,
        searchData,
        formData,
      )
      setOpenModal(uiKey)
      setDesignerPropsData(designerPropsData)
    } else if (action.modalType === 'assessment') {
      objectPath.set(designerPropsData, 'modal', action.assessmentCode)
      designerPropsData = createDesignerData(
        designerPropsData,
        searchData,
        formData,
      )
      setOpenModal(uiKey)
      setDesignerPropsData(designerPropsData)
    }
  }

  const getAction = (action) => {
    switch (action.name) {
      case 'goToForm':
        return goToForm(action)
      case 'goToPage':
        return goToPage(action)
      case 'goToUrl':
        return goToUrl(action)
      case 'openModal':
        return openModal(action)
    }
  }

  return (
    <Card
      id={`${uischema.key}-card`}
      key={uischema.key}
      style={{
        ...style.border,
        cursor: action ? 'pointer' : 'default',
        minWidth: uischema.minWidth,
        maxWidth: uischema.maxWidth,
      }}
      onClick={() => getAction(action)}
    >
      {uischema.title && (
        <Card.Header className={'p-3'} style={style.header}>
          <Card.Title as="h5" style={style.title}>
            <Title {...props} />
          </Card.Title>
        </Card.Header>
      )}
      <Card.Body
        id={`${uischema.key}-card-body`}
        style={{
          padding: uischema.layoutPadding ?? '.5rem',
        }}
      >
        {children}
      </Card.Body>
      {isOpenModal === uiKey && (
        <ModalComponent
          ui={uischema}
          modalAction={action}
          isOpenModal={isOpenModal === uiKey}
          designerPropsData={jsonForm.designerPropsData}
        />
      )}
    </Card>
  )
}

export default CustomCard
